export default "__VITE_ASSET__Cs340fB9__"